import { Spinner } from '@blueprint/ui';

type LoaderProps = {
    bgClassName?: string;
    isLoading?: boolean;
    overlay?: boolean;
    error?: boolean;
    errorFallback?: React.ReactNode;
    children: React.ReactNode;
};

const Loader = ({
    isLoading,
    overlay,
    children,
    bgClassName = "bg-body",
    error,
    errorFallback,
}: LoaderProps): JSX.Element => {
    if (isLoading && !error) {
        if (overlay) {
            return (
                <div className="position-relative">
                    {children}
                    <div
                        className={`position-absolute top-0 bottom-0 start-0 end-0 d-flex align-items-center justify-content-center ${bgClassName}`}
                    >
                        {/*<SpinnerIcon className="m-auto" />*/}
                        <Spinner variant="light.medium"  className="m-auto" label="Loading" />
                    </div>
                </div>
            );
        } else {
            return (
                // <SpinnerIcon className="position-absolute top-50 start-50 translate-middle-x translate-middle-y" />
                <Spinner variant="light.medium"  className="position-absolute top-50 start-50 translate-middle-x translate-middle-y" label="Loading" />
            );
        }
    } else if (error && errorFallback) {
        return <>{errorFallback}</>;
    } else {
        return <>{children}</>;
    }
};

export default Loader;
